import seedrandom from "seedrandom";

const domains = [
    "science",
    "humanities",
    "economics-finance-domain",
    "partner-content",
    "math",
    "math", // Let's be honest -- math is more popular than the rest
    "test-prep",
];

function domainForStory(story) {
    // TODO(alpert): Actually use story content to decide on domain color
    // Seed new RNG with key for consistent seed
    const random = seedrandom("domain:" + story.key);
    return domains[Math.floor(domains.length * random())];
}

export default domainForStory;
